<template lang="pug">
extends ../../../../prototype/src/pug/layout/section_column_gray
include ../../../../prototype/src/pug/abstracts/mixin.pug
block main
	.markdown.passo_a_passo__text_block
		h1 
			strong Vamos descobrir 
			|qual modelo de Certificado você precisa?

	.passo_a_passo__breadcrumb
		.passo_a_passo__breadcrumb--step.enabled 1
		.passo_a_passo__breadcrumb--step 2
		.passo_a_passo__breadcrumb--step 3

	.passo_a_passo__section_title
		strong 1.
		|Para quem é o Certificado Digital?
	.panel__group
		CertificadosItem('v-for'='item in fields' :icon="item.icon", :title="item.title", :description="item.description", :isActive="item.id == target", :route="'/certificados/' + item.id")

	.passo_a_passo__section_title(v-if="reasons")
		strong 2.
		|Qual o motivo do uso?
	.panel__group(v-if="reasons")
		CertificadosItem('v-for'='item in reasons.choices' :description="item.description", :isActive="item.id == reason", :route="'/certificados/' + target + '/' + item.id")

	.passo_a_passo__section_title(v-if="devices")
		strong 3.
		|Qual dispositivo pretende usar?
	.panel__group(v-if="devices")
		CertificadosItem('v-for'='item in devices.choices' :description="item.description", :isActive="item.id == device", :route="'/certificados/' + target + '/' + reason + '/' + item.id")
		CertificadosItemVertical('v-for'='item in devices.items' :icon="item.icon" :title="item.title" :description="item.description", :link_loja="item.url" :link_saiba_mais="item.mais")

	.passo_a_passo__section_title(v-if="links")
		strong.normal O melhor certificado Digital para você é:
	.panel__group(v-if="links")
		CertificadosItemVertical('v-for'='item in links.choices' :icon="item.icon" :title="item.title" :description="item.description", :link_loja="item.url" :link_saiba_mais="item.mais")

mixin cta_painel
	.panel__cta
		a(href="#").button Ir para loja
		a(href="#").button__text Saiba mais

mixin item_vertical(icon=false, title=false, description=false, show_cta=false)
	.panel__wrapper&attributes(attributes)
		.panel__inner
			.panel__header
				if icon
					.panel__icon
						+i(icon)
			.panel__body
				if title
					.panel__title !{title}
				if description
					.panel__description !{description}
			if block
				.panel__footer
					block

mixin item(icon=false, title=false, description=false)
	.panel__wrapper&attributes(attributes)
		.panel__inner--horizontal
			.panel__header
				if icon
					.panel__icon
						+i(icon)
			.panel__body
				if title
					.panel__title !{title}
				if description
					.panel__description !{description}
			if block
				.panel__footer2
					block	
block variables
	- var id = "certificados"
</template>

<script>
import data from "@/assets/escolhas.json";
import CertificadosItem from "@/components/certificados/certificados_item.vue";
import CertificadosItemVertical from "@/components/certificados/certificados_item_vertical.vue";

export default {
	name: "CertificadoComponent",
	components: {
		CertificadosItem,
		CertificadosItemVertical
	},
	data() {
		return {
			fields: data
		}
	},
	computed: {
		reasons: function() {
			if (this.target) {
				for(var i = 0; i < this.fields.length; i++) {
					if (this.fields[i].id == this.target) {
						return this.fields[i];
					}
				}
			}
			
			return null;
		},
		devices: function() {
			if (this.reason && this.reasons) {
				for(var i = 0; i < this.reasons.choices.length; i++) {
					if (this.reasons.choices[i].id == this.reason) {
						return this.reasons.choices[i];
					}
				}
			}
			
			return null;
		},
		links: function() {
			if (this.device && this.devices) {
				for(var i = 0; i < this.devices.choices.length; i++) {
					if (this.devices.choices[i].id == this.device) {
						return this.devices.choices[i];
					}
				}
			}

			return null;
		},
		target: function() {
			return this.$route.params.target;
		},
		reason: function() {
			return this.$route.params.reason;
		},
		device: function() {
			return this.$route.params.device;
		}
	}
}
</script>